import { render } from "./FungiTableView.vue?vue&type=template&id=f45c2f46"
import script from "./FungiTableView.vue?vue&type=script&lang=js"
export * from "./FungiTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__